import React from "react";
import { Link } from "react-router-dom";

const FooterLink = ({ to, title }: { to: string; title: string }) => {
  return (
    <Link
      className="text-gray-500 hover:text-primary transition-colors"
      to={to}
    >
      {title}
    </Link>
  );
};

export default FooterLink;
